import React from 'react'
import { Trans } from '@mc/i18n'
import { i18nInstance, COLLAPSED_PAINTED_DOOR_I18N_NAMESPACE } from '../../i18n'

const t = i18nInstance.getFixedT(null, COLLAPSED_PAINTED_DOOR_I18N_NAMESPACE)

const AnswerComponent = () => (
  <p className='mc-opacity--hinted'>
    <Trans
      i18nKey='faq.general.answer5'
      ns={COLLAPSED_PAINTED_DOOR_I18N_NAMESPACE}
    />
  </p>
)

export const personaFAQ = () => ({
  uuid: 'faq.general.question5',
  label: t(`${COLLAPSED_PAINTED_DOOR_I18N_NAMESPACE}:faq.general.question5`),
  title: t(`${COLLAPSED_PAINTED_DOOR_I18N_NAMESPACE}:faq.general.question5`),
  AnswerComponent,
  answer: <AnswerComponent />,
})
